<template>
  <div class="header-info" v-loading="loading">
    <el-popover placement="bottom" title="Nova mensagem recebida" width="300" trigger="manual" :content="message"
      v-model="alert">
      <el-badge slot="reference" :value="total" :hidden="total === 0" class="header-info__badge" type="primary"
        @click="goto">
        <i @click="goto" class="el-icon-bell header-info__icon"></i>
      </el-badge>
      {{ message }}<br />
      <el-button class="right" type="text" @click="goto()">Visualizar</el-button>
      <el-button class="right" type="text" style="margin-right: 10px;" @click="alert = false">OK</el-button>
    </el-popover>
    <el-badge :value="operator" :hidden="operator === 0" class="header-info__badge" type="info" @click="chat()">
      <i class="fa fa-whatsapp header-info__icon" :class="{ green: operator === 0, 'red': operator > 0 }"
        @click="chat()" aria-hidden="true"></i>
    </el-badge>
  </div>
</template>

<script>
import { NotificationService } from "@/services/comum/notification.services";
export default {
  name: "AppHeaderMenuInfo",
  data() {
    return {
      loading: false,
      message: "",
      alert: false,
      total: 0,
      operator: 0,
    };
  },
  methods: {
    goto() {
      this.alert = false;
      this.$router.replace({ name: 'notification', params: { to: 'message' } }).catch(() => { });
    },
    chat() {
      this.$emit('chat');
    },
  },
  mounted() {
    const vm = this;
    NotificationService.count(1)
      .then((response) => {
        vm.total = +response;
      });
    vm.$bus.$on("readMessage", (action, total) => {
      action === 'subtract'
        ? vm.total = vm.total - total < 0 ? 0 : vm.total - total
        : action === 'set'
          ? vm.total = total
          : vm.total += total;
    });
  }
}
</script>
<style>
/* Ícones de ação do header no mesmo tamanho dos demais itens do menu
   (antes usavam fa-2x — 2x maiores, badge desproporcional). */
.header-info {
  float: right;
  display: flex;
  align-items: center;
  height: 60px;
}

.header-info__badge {
  display: flex;
  cursor: pointer;
  margin-right: 18px;
}

.header-info__icon {
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  color: var(--me-text-regular);
  transition: color 0.2s ease;
}

.header-info__icon:hover {
  color: var(--me-primary);
}

.header-info__badge .el-badge__content {
  font-size: 10px;
  height: 16px;
  line-height: 15px;
  padding: 0 5px;
}

.header-info__icon.green {
  color: #25d366;
}

.header-info__icon.red {
  color: var(--me-danger);
}
</style>